/*
 * Slow automatic drift for product carousels.
 *
 * Native port of the Variant experience exp-EXPAFE5E1A9 ("PDP motion for
 * carousels"). Unlike the other ported experiences this one has nothing to
 * render: it only animates scroll position, so it stays in JavaScript. What
 * changed is where it lives and what it costs to run - see the notes on the
 * discovery pass and the reduced-motion check below.
 *
 * Styles live in assets/custom.css.
 */
(function () {
  'use strict';

  var MARKER = 'data-carousel-drift';
  var PX_PER_SECOND = 15;
  var RESUME_DELAY_MS = 1200;

  // A carousel that creeps sideways forever, with no control to stop it, is
  // exactly what this setting is for. The original had no such check.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var entries = [];
  var observer = null;

  /**
   * Which way to push scrollLeft so the carousel travels left to right.
   * Browsers disagree on the sign of scrollLeft in RTL documents, so rather
   * than guess from the computed direction this nudges the element once and
   * watches what actually moves.
   */
  function probeDirection(element) {
    var start = element.scrollLeft;

    element.scrollLeft = start + 50;
    if (element.scrollLeft !== start) {
      element.scrollLeft = start;
      return -1;
    }

    element.scrollLeft = start - 50;
    if (element.scrollLeft !== start) {
      element.scrollLeft = start;
      return -1;
    }

    // Already pinned against an edge: find which range this element uses.
    element.scrollLeft = 99999;
    if (element.scrollLeft > 10) return -1;

    element.scrollLeft = -99999;
    if (element.scrollLeft < -10) return 1;

    return -1;
  }

  function register(element, options) {
    if (!element || element.hasAttribute(MARKER)) return;
    element.setAttribute(MARKER, 'true');

    options = options || {};
    var entry = {
      element: element,
      visible: false,
      paused: false,
      probed: !!options.sign,
      sign: options.sign || 0,
      seeded: false,
      seedToEnd: options.seedToEnd !== false,
      frame: null,
      lastFrameTime: 0,
      resumeTimer: null
    };

    entries.push(entry);
    observer.observe(element);
    bindPause(entry);
  }

  function discover() {
    // Injected by the bundle experience (exp-EXPCB2DD8BB), which still runs
    // client-side - hence a selector with nothing behind it in the theme.
    register(document.querySelector('#variant-bundle-section .bundle-carousel-track'), {
      sign: -1,
      seedToEnd: false
    });

    document.querySelectorAll('scroll-carousel.product-list--carousel').forEach(function (element) {
      // The product gallery drives its own scrolling.
      if (element.classList.contains('product-gallery__carousel')) return;
      register(element);
    });

    document
      .querySelectorAll('scroll-carousel[id*="featured-collections-product-list-carousel"]')
      .forEach(function (element) {
        register(element);
      });
  }

  // -------------------------------------------------------------------------
  // Drift
  // -------------------------------------------------------------------------
  function start(entry) {
    if (entry.frame || entry.paused) return;
    entry.lastFrameTime = 0;

    if (!entry.probed) {
      entry.probed = true;
      entry.sign = probeDirection(entry.element);
    }

    if (!entry.seeded) {
      entry.seeded = true;
      if (entry.seedToEnd && entry.sign < 0) {
        entry.element.scrollLeft = 99999;
        if (Math.abs(entry.element.scrollLeft) < 5) entry.element.scrollLeft = -99999;
      }
    }

    function step(now) {
      if (entry.paused || !entry.visible) {
        entry.frame = null;
        return;
      }

      if (entry.lastFrameTime > 0) {
        // A long gap means the tab was in the background; treat it as one
        // ordinary frame rather than lurching forward.
        var elapsed = (now - entry.lastFrameTime) / 1000;
        if (elapsed > 0.1) elapsed = 0.016;
        entry.element.scrollLeft += PX_PER_SECOND * elapsed * entry.sign;
      }

      entry.lastFrameTime = now;
      entry.frame = requestAnimationFrame(step);
    }

    entry.frame = requestAnimationFrame(step);
  }

  function stop(entry) {
    entry.lastFrameTime = 0;
    if (!entry.frame) return;
    cancelAnimationFrame(entry.frame);
    entry.frame = null;
  }

  /** Hand control back to the visitor the moment they touch the carousel. */
  function bindPause(entry) {
    var element = entry.element;

    function pause() {
      entry.paused = true;
      clearTimeout(entry.resumeTimer);
      entry.resumeTimer = null;
      stop(entry);
    }

    function scheduleResume() {
      entry.paused = false;
      clearTimeout(entry.resumeTimer);
      entry.resumeTimer = setTimeout(function () {
        entry.resumeTimer = null;
        if (entry.visible && !entry.paused) start(entry);
      }, RESUME_DELAY_MS);
    }

    element.addEventListener('touchstart', pause, { passive: true });
    element.addEventListener('mousedown', pause);
    element.addEventListener('touchend', scheduleResume, { passive: true });
    element.addEventListener('mouseup', scheduleResume);
    element.addEventListener(
      'wheel',
      function () {
        pause();
        scheduleResume();
      },
      { passive: true }
    );
  }

  observer = new IntersectionObserver(
    function (observed) {
      observed.forEach(function (record) {
        var entry = null;
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].element === record.target) {
            entry = entries[i];
            break;
          }
        }
        if (!entry) return;

        entry.visible = record.isIntersecting;
        if (entry.visible && !entry.paused) {
          start(entry);
        } else {
          stop(entry);
        }
      });
    },
    { threshold: 0.1 }
  );

  discover();

  /*
   * The original re-ran discovery from a MutationObserver watching every
   * childList change in the whole document subtree - so three querySelectorAll
   * sweeps fired on any DOM activity anywhere on the page, cart updates
   * included. Carousels only ever arrive with a section, and the theme
   * announces those.
   */
  document.addEventListener('shopify:section:load', discover);
})();
